export default "__VITE_ASSET__CHiLhdwV__"